export const initSubscriberRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/subscribers",
          name: "subscriber",
          component: () => import("@/pages/manage/subscribers/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.subscriberManager,
            ],
          },
        },
        {
          path: "/manage/subscribers/:id",
          name: "subscriber-id",
          component: () => import("@/pages/manage/subscribers/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.subscriberManager,
            ],
          },
        },
      ];
